import { render, staticRenderFns } from "./PatientDetailPolicy.vue?vue&type=template&id=578b25d6&scoped=true"
import script from "./PatientDetailPolicy.vue?vue&type=script&lang=js"
export * from "./PatientDetailPolicy.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailPolicy.vue?vue&type=style&index=0&id=578b25d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578b25d6",
  null
  
)

export default component.exports